import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 15",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m8.014 14.367-.503-.476-6.25-6.25a4.306 4.306 0 0 1 6.09-6.088l.65.65.649-.65a4.306 4.306 0 1 1 6.089 6.089l-6.725 6.724Zm-.032-1.899.023.022 5.791-5.79a2.973 2.973 0 1 0-4.203-4.204L8 4.088 6.408 2.496a2.972 2.972 0 0 0-4.204 4.203l5.774 5.774.004-.005Z" }, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }